import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import { storage } from "../firebase";
import moment from 'moment';
import { db, database, storyRef} from '../firebase'
import $ from 'jquery';
import ContentTextEditor from './newStoriesEditor'

export default class NewStories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title:"",
            status:"",
            category:"",
            mainCategory:"",
            description:"",
            shortDescription:"",
            storyCategoryData:[]
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleShortDescriptionChange = this.handleShortDescriptionChange.bind(this);
        this.validateSubmission = this.validateSubmission.bind(this);
        this.updateValidateSubmission = this.updateValidateSubmission.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMainCategoryChange = this.handleMainCategoryChange.bind(this);
    }
    async componentDidMount() {
        const url = new URL(window.location.href);
        let url_path = window.location.href.split("=");
        let keyId = (url_path[1]);
        this.renderList(keyId)

    }
    async renderList(keyId) {
        
        let dataList = []
        let id = keyId;
        const ref = id ? '/stories/' + id : 'stories'
        const userRef = database.ref(ref)
        const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
        const snapshot = await valueRef.once('value')
        const val = snapshot.val()
        if (val) {
            $("#storyTitle").val(val.title)
            $("#storyImage").val(val.imageUrl)
            $("#storyStatus").val(val.status)
            let storyCategoryList=[]
            await database.ref("storyCategory").once('value',function(snapshot){
                snapshot.forEach(function(ChildSnapshot){
                    if(ChildSnapshot.val().status == 'Active' && val.mainCategory === ChildSnapshot.val().mainCategory){
                        storyCategoryList.push({
                            key:ChildSnapshot.key,
                            name:ChildSnapshot.val().name
                        });
                    }
                });
            });
            this.setState({
                storyCategoryData:storyCategoryList
            })
            $("#storyCategory").val(val.category)
            $("#mainCategory").val(val.mainCategory)
            $("#shortDescription").val(val.shortDescription)
            var textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view")
            textEditorContent.innerHTML = val.description
            
            this.setState({
                storyUrl: val.imageUrl,
                id: id,
                title: val.title,
                status: val.status,
                storyImage: val.imageUrl,
                description:val.description,
                shortDescription:val.shortDescription,
                category:val.category,
                mainCategory:val.mainCategory,
            })
        }
    }
    updateValidateSubmission = (url) => {
        var textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view")
        var description  = textEditorContent.innerHTML;
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            title: this.state.title,
            imageUrl: url ? url : this.state.storyUrl  ,
            description:description,
            shortDescription:this.state.shortDescription,
            category:this.state.category,
            mainCategory:this.state.mainCategory,
            status: this.state.status,
            createdAt: newDate

        }
        database.ref(`stories/${this.state.id}`).update(item).then(() => {
            alert("Updated Successfully")
            window.location.href = "/stories"
             this.renderList();
           
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    validateSubmission = () => {
        
        if (this.state.title === '') {
            alert('Enter Title')
        }
        else if (this.state.storyImage === '' || this.state.storyImage === undefined) {
            alert('Upload File ')
        }
        else if (this.state.mainCategory === '') {
            alert('Select main category')
        }
        else if (this.state.category === '') {
            alert('Select category')
        }
        else if (this.state.status === '') {
            alert('Select status')
        }
        else if (this.state.shortDescription === '') {
            alert('Enter short description')
        }
        else {
            if (this.state.fileName) {
                const uploadTask = storage.ref(`stories/${this.state.storyImage.name}`).put(this.state.storyImage);
                uploadTask.on(
                    "state_changed",
                    snapshot => {
                        const progress = Math.round(
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                        );
                        this.setState({
                            progress: progress
                        })
                    },
                    error => {
                        console.log(error);
                    },
                    () => {
                        storage
                            .ref("stories")
                            .child(this.state.storyImage.name)
                            .getDownloadURL()
                            .then(url => {
                                $("#imageUrl")
                                .attr('src', url);
                                this.setState({
                                    url: url
                                })
                                if (this.state.id == null) {
                                    this.handleSubmit(url);
                                }
                                else {
                                    this.updateValidateSubmission(url)
                                }
                            });

                    }
                );
             }
            else {
                if (this.state.id == null) {
                    this.handleSubmit("");
                }
                else {
                    this.updateValidateSubmission("");
                }
            }
        }
    }
    handleSubmit = (url) => {
        var textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view")
        var description  = textEditorContent.innerHTML;
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            title: this.state.title,
            imageUrl: url ? url : this.state.storyUrl  ,
            description:description,
            shortDescription:this.state.shortDescription,
            category:this.state.category,
            mainCategory:this.state.mainCategory,
            status: this.state.status,
            createdAt: newDate
        }
        storyRef.push(item).then(() => {
            alert("Saved Successfully")
            window.location.href = "/stories"
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    handleImageChange = e => {
        if (e.target.files[0]) {
            this.setState({
                storyImage: e.target.files[0],
                fileName:true
            })
        }
    };
    handleStatusChange = (e) => {
        this.setState({
            status: e.target.value
        })
    }
    handleMainCategoryChange = async (e) => {
        this.setState({
            mainCategory: e.target.value
        })
        let mainCategory = e.target.value
        let storyCategoryList=[]
        await database.ref("storyCategory").once('value',function(snapshot){
            snapshot.forEach(function(ChildSnapshot){
                if(ChildSnapshot.val().status == 'Active' && mainCategory === ChildSnapshot.val().mainCategory){
                    storyCategoryList.push({
                        key:ChildSnapshot.key,
                        name:ChildSnapshot.val().name
                    });
                }
            });
        });
        this.setState({
            storyCategoryData:storyCategoryList
        })
    }
    handleCategoryChange = (e) => {
        this.setState({
            category: e.target.value
        })
    }
    handleChange = (e) => {
        this.setState({
            title: e.target.value,
        });
    };
    handleShortDescriptionChange = (e) => {
        this.setState({
            shortDescription: e.target.value,
        });
    };
    
    // uploadImageCallBack = (file, callback) => {
    //     console.log(file);
    //     return new Promise((resolve, reject) => {
    //         const reader = new window.FileReader();
    //         console.log(reader);
    //         reader.onloadend = async () => {
    //             const form_data = new FormData();
    //             form_data.append("file", file);
    //             // const res = await uploadFile(form_data);
    //             // setValue("thumbnail", res.data);
    //             // resolve({ data: { link: process.env.REACT_APP_API + res.data } });
    //         };
    //         reader.readAsDataURL(file);
    //     });
    // };


    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <form className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li><a href="/stories">Stories</a></li>
                                    <li>New Stories</li>
                                </ul>
                                <div className='form-head'>Stories</div>
                                <div className="form-group">
                                    <label for="storyTitle">Title</label>
                                    <input type="text" className="form-control" name="storyTitle" onChange={this.handleChange}
                                        id="storyTitle"
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="imageUrl">Image/Video</label>
                                    <input type="file" onChange={this.handleImageChange} id="imageUrl" name="imageUrl" className="form-group"></input>
                                     {this.state.fileName || this.state.storyUrl && <img src={this.state.storyUrl} id={"imageUrl"} style={{ width: "100px", height: "100px" }} />}
                                </div>
                                <div className="form-group">
                                    <label for="storyCategory">Main Category</label>
                                    <select className="form-control" onChange={this.handleMainCategoryChange} id="mainCategory" name="mainCategory">
                                        <option value="">Select</option>
                                        <option value="Course Reviews">Course Reviews</option>
                                        <option value="Stories">Stories</option>
                                        <option value="Blogs">Blogs</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label for="storyCategory"> Category</label>
                                    <select className="form-control" onChange={this.handleCategoryChange} id="storyCategory" name="storyCategory">
                                        <option value="">Select</option>

                                        {
                                                this.state.storyCategoryData.map( (x,y) => 
                                                  <option key={y}>{x.name}</option> )
                                              }
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label for="storyStatus"> Status</label>
                                    <select className="form-control" onChange={this.handleStatusChange} id="storyStatus" name="storyStatus">
                                        <option value="">Select</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label for="storyStatus"> Short Description</label>
                                    <textarea className="form-control" name="shortDescription"
                                            id="shortDescription" onChange={this.handleShortDescriptionChange}
                                            defaultValue={this.state.shortDescription}
                                        ></textarea>
                                </div>
                                <div className="form-group">
                                    <label for="storyStatus">Description</label>
                                    <ContentTextEditor textEditorName={"story"}>

                                    </ContentTextEditor>
                                </div>
                                <div className="form-group mt-4">
                                    <Link to="/stories">
                                        <button type="button" className="btn btn-primary" style={{ float:"right",marginLeft: "10px" }}>Cancel</button>
                                    </Link>
                                    {this.state.id == null ?
                                        <button type="button" className="btn btn-primary" style={{ float:"right" }} onClick={this.validateSubmission}>Submit</button>
                                        :
                                        <button type="button" className="btn btn-primary" style={{ float: "right" }} onClick={this.validateSubmission}>Update</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        )
    }

}
const styles = {
    editor: {
        border: '1px solid gray',
        minHeight: '6em'
    }
};


// WEBPACK FOOTER //
// ./src/admin/newStories.jsx